import { Outlet } from "react-router";

import ChurnZero from "@/containers/Root/ChurnZero";
import GoogleAnalytics from "@/containers/Root/GoogleAnalytics";

const RootLayout = () => {
  return (
    <>
      <ChurnZero />
      <GoogleAnalytics />
      <Outlet />
    </>
  );
};

export default RootLayout;
